import ActiveController from "rapid/controller";

export class scenePreviewController extends ActiveController {
    constructor($injector, $rootScope, $element, $scope) {
        "ngInject";
        super($injector);

        this.$rootScope = $rootScope;
        this.$element = angular.element($element);
        this.$scope = $scope;
        this.mainSceneStyle = {};
        this.photoStyle = {};
    }

    $onInit() {
        this.layoutWidth = this.removePixels(this.layoutWidth);
        this.layoutHeight = this.removePixels(this.layoutHeight);
        this.getSceneSize();

        this.$scope.$watch(() => this.sceneWidth, () => {
            this.getSceneSize();
        });
        this.$scope.$watch(() => this.sceneHeight, () => {
            this.getSceneSize();
        });
        this.$scope.$watch(() => this.photo ? this.photo.width : null, () => {
            this.getSceneSize();
        });
        this.$scope.$watch(() => this.photo ? this.photo.height : null, () => {
            this.getSceneSize();
        });
        this.$scope.$watch(() => this.photo ? this.photo.x : null, () => {
            this.getSceneSize();
        });
        this.$scope.$watch(() => this.photo ? this.photo.y : null, () => {
            this.getSceneSize();
        });
        this.$scope.$watch(() => this.photo ? this.photo.angle : null, () => {
            this.getSceneSize();
        });
        this.$scope.$watch(() => this.hideScene , () => {
            this.getPhotoStyle();
        });
    }

    getSceneSize() {
        if (this.sceneWidth/this.sceneHeight > this.layoutWidth/this.layoutHeight) {
            this.mainSceneStyle = {
                width: this.layoutHeight * this.sceneWidth/this.sceneHeight,
                height: this.layoutHeight,
                top: 0,
                right: (this.layoutHeight * (this.sceneWidth/this.sceneHeight) - this.layoutWidth)/2
            };
        } else {
            this.mainSceneStyle = {
                height: this.layoutWidth * this.sceneHeight/this.sceneWidth,
                width: this.layoutWidth,
                right: 0,
                bottom: (this.layoutWidth * (this.sceneHeight/this.sceneWidth) - this.layoutHeight)/2
            };
        }
        this.mainSceneStyle.width += "px";
        this.mainSceneStyle.height += "px";
        this.mainSceneStyle.bottom += "px";
        this.mainSceneStyle.right += "px";
        this.mainSceneStyle.top += "px";
        this.getPhotoStyle();
    }

    getPhotoStyle() {
        if (!this.photo) return;
        if (this.hideScene) {
            this.photoStyle = {
                width: 100 + "%",
                height: 100  + "%",
                left: 0,
                top: 0,
            };
        } else {
            this.photoStyle = {
                width: this.photo.width * 100 / this.sceneWidth + "%",
                height: this.photo.height * 100 / this.sceneHeight + "%",
                left: this.photo.x * 100 / this.sceneWidth + "%",
                top: this.photo.y * 100 / this.sceneHeight + "%",
                transform: `rotate(${this.photo.angle}deg)`
            };
        }
    }

    removePixels(value) {
        value = value.substring(0, value.length - 2);
        return Number(value);
    }

    getBgImage() {
        if (this.backgroundFiles && this.backgroundFiles.length) {
            if (this.photoIndex === 0 || this.photoIndex === 3) {
                return `url(${this.backgroundFiles[0].attachment_file.includes(".gif")? this.backgroundFiles[0].first_frame : this.backgroundFiles[0].attachment_file})`;
            } else if (this.photoIndex === 1 || this.photoIndex === 4) {
                let average = Math.ceil(this.backgroundFiles.length/2) -1;
                return `url(${this.backgroundFiles[average].attachment_file.includes(".gif")? this.backgroundFiles[average].first_frame : this.backgroundFiles[average].attachment_file})`;
            } else if (this.photoIndex === 2 || this.photoIndex === 5) {
                return `url(${this.backgroundFiles[this.backgroundFiles.length - 1].attachment_file.includes(".gif")? this.backgroundFiles[this.backgroundFiles.length - 1].first_frame : this.backgroundFiles[this.backgroundFiles.length - 1].attachment_file})`;
            }
        }
    }
    getOverlayImage() {
        if (this.overlayFiles && this.overlayFiles.length) {
            if (this.photoIndex === 0 || this.photoIndex === 3) {
                return `url(${this.isMovie(this.overlayFiles[0].attachment_file) ? this.overlayFiles[0].first_frame_alpha : this.overlayFiles[0].attachment_file})`;
            } else if (this.photoIndex === 1 || this.photoIndex === 4) {
                let average = Math.ceil(this.overlayFiles.length/2) -1;
                return `url(${this.isMovie(this.overlayFiles[average].attachment_file) ? this.overlayFiles[average].first_frame_alpha : this.overlayFiles[average].attachment_file})`;
            } else if (this.photoIndex === 2 || this.photoIndex === 5) {
                return `url(${this.isMovie(this.overlayFiles[this.overlayFiles.length - 1].attachment_file) ? this.overlayFiles[this.overlayFiles.length - 1].first_frame_alpha : this.overlayFiles[this.overlayFiles.length - 1].attachment_file})`;
            }
        }
    }
    isMovie(name) {
        if (name === undefined || name === null) {
            return false;
        } else {
            return (
                name.indexOf(".mp4") !== -1 ||
                name.indexOf(".webm") !== -1
            );
        }
    }
}



// WEBPACK FOOTER //
// ./sources/components/common/scene-preview/scene-preview.controller.js